<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <fieldset disabled style="border: none">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="提现号" prop="extractNo">
                            <Input v-model="info.extractNo" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="申请时间" prop="createTime">
                            <DatePicker
                                v-model="createTime"
                                transfer
                                style="width: 100%;"
                                type="datetime"
                                disabled
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="姓名" prop="realname">
                            <Input v-model="info.realname" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="手机号" prop="phone">
                            <Input v-model="info.phone" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="可提现金额" prop="leftAmount">
                            <input-number v-model="info.leftAmount" placeholder>
                                <span slot="append">元</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="提现金额" prop="amount">
                            <input-number v-model="info.amount" placeholder>
                                <span slot="append">元</span>
                            </input-number>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="转账方式" prop="transferType">
                            <Input v-model="info.transferType" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="提现状态" prop="extractStatus">
                            <Select v-model="info.extractStatus" transfer disabled placeholder>
                                <Option
                                    v-for="(item, index) in extractStatusList"
                                    :value="item.id"
                                    :key="index"
                                >{{ item.text }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="确认人" prop="confirmUser">
                            <Input v-model="info.confirmUser" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="确认时间" prop="confirmTime">
                            <DatePicker
                                v-model="confirmTime"
                                transfer
                                style="width: 100%;"
                                type="datetime"
                                disabled
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="24">
                        <FormItem label="确认说明" prop="confirmRemark">
                            <Input
                                v-model="info.confirmRemark"
                                type="textarea"
                                :rows="4"
                                placeholder
                            ></Input>
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="结佣人" prop="commissionUser">
                            <Input v-model="info.commissionUser" :maxlength="256" placeholder></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="结佣时间" prop="commissionTime">
                            <DatePicker
                                v-model="commissionTime"
                                transfer
                                style="width: 100%;"
                                type="datetime"
                                disabled
                            ></DatePicker>
                        </FormItem>
                    </Col>
                </Row>
            </fieldset>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="结佣说明" prop="commissionRemark">
                        <Input
                            v-model="info.commissionRemark"
                            type="textarea"
                            :rows="4"
                            placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20" v-if="payType">
                <Col span="24">
                    <FormItem label="上传凭证图片" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="1"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { sExtractView, sExtractCommission } from "@/api/sell";
import Dict from "_u/dict";
import { ymdL, toDate } from "_u/helper";
import config from "@/config";
import PreviewUpload from "_c/preview-upload";

export default {
    name: "s-extract-commission-form",

    props: {
        id: {
            type: [String, Number],
            default: "",
        },
        payType: {
            type: [String, Number],
            default: 0, // 默认线上
        },
    },

    components: {
        PreviewUpload,
    },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: this.id,
                extractNo: "", // 提现号
                createTime: "", // 申请时间
                realname: "", // 姓名
                phone: "", // 手机号
                leftAmount: "", // 可提现金额
                amount: "", // 提现金额
                transferType: "", // 转账方式
                extractStatus: "", // 提现状态
                confirmUser: "", // 确认人
                confirmTime: "", // 确认时间
                confirmRemark: "", // 确认说明
                commissionUser: "", // 结佣人
                commissionTime: "", // 结佣时间
                commissionRemark: "", // 结佣说明
                ver: "", // 版本号
                attachments: "", // 上传图片 线下传
            },

            dict: {
                transferWay: Dict.NULL,
                extractStatus: Dict.NULL,
            },

            imgSuffix: config.upload.imgSuffix,
        };
    },

    computed: {
        ruleValidate() {
            const vaildateAttachments = (rule, value, callback) => {
                if (this.payType === 1 && !value) {
                    callback(new Error("必须上传凭证图片"));
                } else {
                    callback();
                }
            };
            return {
                attachments: [{ validator: vaildateAttachments }],
            };
        },

        createTime: {
            get() {
                return this.info.createTime ? toDate(this.info.createTime) : "";
            },
            set(val) {
                this.info.createTime = ymdL(val);
            },
        },
        confirmTime: {
            get() {
                return this.info.confirmTime
                    ? toDate(this.info.confirmTime)
                    : "";
            },
            set(val) {
                this.info.confirmTime = ymdL(val);
            },
        },
        commissionTime: {
            get() {
                return this.info.commissionTime
                    ? toDate(this.info.commissionTime)
                    : "";
            },
            set(val) {
                this.info.commissionTime = ymdL(val);
            },
        },

        transferTypeList() {
            return this.dict.transferWay.toList();
        },
        extractStatusList() {
            return this.dict.extractStatus.toList();
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return sExtractView(this.id);
            } else {
                return Promise.resolve();
            }
        },
    },

    mounted() {
        var $info = this.$refs.info;

        // 按钮配置
        var btns = [{ type: "default", text: "取消", name: "cancel" }];

        if (this.$can("update")) {
            btns.unshift({
                type: "primary",
                name: "confirm",
                text: "确定",
            });
        }
        this.$modal.updateBtns(btns);

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(["transfer_type", "extract_status"]),
                this.fetch(),
            ])
                .then((args) => {
                    var [dictGroup, view] = args;

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    if (view) {
                        var viewData = view.data;
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity;

                        viewData.amount /= 100;
                        viewData.leftAmount /= 100;

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        );
                    }
                })
                .finally(() => {
                    next();
                });
        });

        // 确定
        this.$modal.onBtnClick("confirm", (next, options) => {
            $info
                .validate()
                .then(() => {
                    var formData = {
                        id: this.info.id,
                        commissionRemark: this.info.commissionRemark,
                        attachments: this.info.attachments,
                        payType: this.payType,
                    };
                    return sExtractCommission(formData);
                })
                .then((res) => {
                    this.$Message.success(this.$t("tips.update.success"));
                })
                .catch((err) => {
                    options.closeModal = false;
                })
                .finally(() => {
                    next();
                });
        });
    },
};
</script>
<style lang="less" scoped></style>
